import { forwardRef, type Ref, type SVGProps } from "react";
const IconMailOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2M4 9.27l7.74 7.21L4 23.72zm12 8.43L5.54 8h20.92zm12-8.43v14.45l-7.74-7.24zm-14.79 8.56 2.06 1.89a1.1 1.1 0 0 0 1.46 0l2.06-1.89 6.6 6.17H6.61z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMailOutlineSVG);
ForwardRef.displayName = "IconMailOutline";
export { ForwardRef as IconMailOutline };
